@if (chatBotSvc.isDisplayed$()) {
  <azavista-icon-button (click)="close()" icon="close" color="primary"></azavista-icon-button>
}
